import * as React from 'react';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
//import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useTranslation } from '../../language';


export default function OnboardingSteps({ stepNumber = 0 }) {

  const { t, language } = useTranslation();

    const steps = [
  t("onb_step1"),
  t("onb_step2"),
  t("onb_step3"),
  t("onb_step4"),
  t("onb_step5"),
];

  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());

  const isStepOptional = (step) => {
    return step === 5;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSkip = () => {
    if (!isStepOptional(activeStep)) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  return (


   

      <Stepper activeStep={ stepNumber } alternativeLabel sx={{ px: { xs: 0, sm: 2 }, width: '100%' }}>
        {steps.map((label, index) => {
          const stepProps = {};
          const labelProps = {};

          // Add custom styling
              labelProps.StepIconProps = {
                sx: {
                  fontSize: { xs: '1.5rem', sm: '2rem' },

                  color: 'grey.C400', // Incomplete steps
                  '&.Mui-active': {
                    color: 'warning.light', // Active step
                  },
                  '&.Mui-completed': {
                    color: 'success.main', // Completed steps
                  },
                }
              };

          if (isStepOptional(index)) {
            labelProps.optional = (
              <Typography variant="caption">Optional</Typography>
            );
          }
          if (isStepSkipped(index)) {
            stepProps.completed = false;
          }
          return (
            <Step key={label} {...stepProps} >
              <StepLabel {...labelProps} sx={{
                                            '& .MuiStepLabel-label': {
                                              fontSize: { xs: '0.62rem', sm: '0.8rem' },
                                              fontWeight: 400
                                            }
                                            }}>
                      {label}
                
                </StepLabel>
            </Step>
          );
        })}
      </Stepper>

     
  
  );
}
